<script lang="ts">
  import Blocks from './strapi/Blocks.svelte';
  import StrapiDevEditBox from './strapi/dev/EditBox.svelte';
  import MetaAuthor from './strapi/MetaAuthor.svelte';

  import { dev } from '$app/environment';
  import { page } from '$app/stores';
  import { sendPlausibleEvent } from '$lib/client/plausible.js';
  import { SidebarCollapsed, AnchorNavigation } from '.';
  import { Separator } from '$lib/components/ui/separator';

  export let data;

  const pathParts = $page.url.pathname.split('/');
  const contentType = pathParts[1]; // This will be 'tutorials' or 'guides'

  const collectionType =
    contentType === 'tutorials' ? 'api::tutorial.tutorial' : 'api::guide.guide';
</script>

{#if data.sidebarNavigationItems}
  <SidebarCollapsed
    navigation={data.sidebarNavigationItems}
    currentPathName={$page.url.pathname}
    currentUrlHash={$page.url.hash}
    isDesktopOpen={true}
  />
{/if}
<div class="min-w-0 max-w-2xl flex-auto md:px-4 py-16 lg:max-w-none lg:pr-0 lg:pl-8 xl:px-16">
  <article>
    {#if data.article?.attributes?.meta?.title}
      <StrapiDevEditBox
        isDev={dev}
        button={{
          editUrl: `${PUBLIC_STRAPI_BASE_URL}/admin/content-manager/collectionType/${collectionType}/${data.article?.id}`,
          text: contentType === 'tutorials' ? 'Edit Tutorial' : 'Edit Guide'
        }}
      >
        <div class="mb-0">
          <h1 class="scroll-m-20 text-4xl font-bold tracking-tight">
            {data.article?.attributes?.meta?.title}
          </h1>
        </div>

        {#if data.article?.attributes?.meta?.excerpt}
          <div class="mt-2">
            <p class="text-balance text-lg text-muted-foreground">
              {data.article?.attributes?.meta?.excerpt}
            </p>
          </div>
        {/if}
      </StrapiDevEditBox>
    {/if}

    <Separator class="my-4" />

    {#if data.article?.attributes?.blocks}
      <Blocks
        blocks={data.article?.attributes?.blocks}
        on:analytics-event={(e) => sendPlausibleEvent(e.detail)}
        on:newsletter-subscribe-event={(e) => {}}
        dev={{
          strapiBaseUrl: PUBLIC_STRAPI_BASE_URL,
          isDev: dev
        }}
      />
    {/if}
  </article>
</div>
{#if data.article?.attributes?.blocks}
  <div
    class="hidden xl:sticky xl:top-[4.5rem] xl:-mr-6 xl:block xl:h-[calc(100vh-4.5rem)] xl:flex-none xl:overflow-y-auto xl:py-16 xl:pr-6"
  >
    <AnchorNavigation
      blocks={data.article.attributes.blocks}
      options={{ includeHeadings: [2, 3, 4] }}
    />
  </div>
{/if}
